import styles from "./styles.module.css";
import { AppUnderlinedTitle } from "../../../../../../../shared/components/AppUnderlinedTitle";
import { hidePartialString } from "../../../../../../../shared/utils/hidePartialString";
import { AppButton } from "../../../../../../../shared/components/AppButton";
import { ObjectRefContainer } from "../../../../../../../common/ObjectRefContainer";
import { ChatbotValue } from "../../../../../../../services/api/instances/botApi/types";
import { NormalizedStorageObject } from "../../../../../../../services/api/instances/storageApi/types/object_types";
import { RenameObjectInput } from "../../../../../../../common/RenameObjectInput";

interface Props {
  bot: NormalizedStorageObject<ChatbotValue> | null;
  title: string;
  label: string;
  name: string;
  api: string;
  handleChangeApi: (token: string) => void;
}

export const BotMainInfo = (props: Props) => {
  return (
    <>
      <AppUnderlinedTitle
        className={styles.title}
        leftContent={props.title}
        children={
          <RenameObjectInput
            service={"ai_agents_telegram_bots"}
            inputType={"input"}
          />
        }
      />
      <div className={styles.container}>
        <div className={styles["left-info"]}>
          <p className={styles["bot-name"]}>{props.name}</p>
          <div className={styles["api-container"]}>
            <p className={styles["bot-api"]}>
              <span className={styles["bot-api-header"]}>
                Telegram bot API:{" "}
              </span>
              <span className={styles["bot-api-content"]}>
                {hidePartialString(props.api)}
              </span>
            </p>
            <AppButton
              small
              buttonType="text"
              className={styles["change-button"]}
              onClick={() => props.handleChangeApi(props.api)}
            >
              {props.label}
            </AppButton>
          </div>
        </div>
        <div className={styles["ref-block"]}>
          <ObjectRefContainer refValue={props.bot?.ref ?? ""} />
        </div>
      </div>
    </>
  );
};
